import { render } from "./conference-hall.vue?vue&type=template&id=cca143b0"
import script from "./conference-hall.vue?vue&type=script&lang=js"
export * from "./conference-hall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__